import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import index from "@beeldit/core/services";
import { FiltersContext } from "../filters/FiltersContext";
import { TicketsGraphContext } from "./TicketsGraphContext";

function useTicketsIndex() {
  const { setGraphData } = useContext(TicketsGraphContext);
  const { tableFilters } = useContext(FiltersContext);
  const errorHandler = useErrorHandler();
  return () => {
    let filterPath = "measure=tickets";
    if (tableFilters) {
      for (const [key, value] of Object.entries(tableFilters)) {
        if (value) {
          filterPath += `&${key}=${value}`;
        }
      }
    }
    index("graph", filterPath)
      .then((response: any) => {
        setGraphData(response.data);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useTicketsIndex;
